export default "__VITE_ASSET__C9NhrsMw__"